export const registrationNotRequired = ['ND'];
export const registrationPrintMailDisabled = ['NH'];
export const registrationPrintMailRequiresNotary = ['WY'];
export const ineligibleStates =
  registrationNotRequired + registrationPrintMailDisabled;
export const registrationLeoReferralIfWillNotBe18 = ['DE', 'LA'];
export const registrationNoStateFormAvailable = ['CA', 'IL'];
export const registrationEligibilityDaysFrom18 = {
  AK: 90,
};
